/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Note2Inputs */

const en_coinvestments_report_snapshotform_note2 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Note2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Coinvestments_Report_Snapshotform_Note2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_note2 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Note2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Note2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_note2(inputs)
});
export { coinvestments_report_snapshotform_note2 as "coInvestments_report_snapshotForm_note" }